import React, { useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { LogIn, Mail, Lock } from "lucide-react";
import loginicon from "../Assets/dbskills-logo.webp";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { loginAdmin } from "../Api/authApi";

const LoginPage = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email.trim() || !password.trim()) {
      toast.error("Please fill in all fields");
      return;
    }

    try {
      setLoading(true);
      const res = await loginAdmin({
        username: email,
        password: password,
      });

      console.log("Login Response:", res);
if (res.success) {
  if (res.role !== "admin" && res.role !== "superadmin") {
    toast.error("Access denied. Authorized users only.");
    return;
  }

  // ✅ STORE TOKEN & ROLE
  localStorage.setItem("token", res.token);
  localStorage.setItem("role", res.role);

  toast.success("✓ Login successful!");
  if (res.role === "superadmin") {
    navigate("/superadmin/dash");
  } else {
    navigate("/dash");
  }
} else {
        toast.error(res.message);
      }
    } catch (error) {
      toast.error("Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-gradient-to-br from-blue-50 via-white to-indigo-50 p-4 relative overflow-hidden">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@500;600;700;800&display=swap');
        
        body {
          font-family: 'Plus Jakarta Sans', sans-serif;
        }

        .login-container {
          animation: fadeInScale 0.6s ease-out forwards;
          opacity: 0;
        }

        @keyframes fadeInScale {
          from {
            opacity: 0;
            transform: scale(0.95);
          }
          to {
            opacity: 1;
            transform: scale(1);
          }
        }

        .glass-effect {
          background: linear-gradient(135deg, rgba(255, 255, 255, 0.95) 0%, rgba(249, 250, 251, 0.95) 100%);
          backdrop-filter: blur(20px);
          border: 1px solid rgba(99, 102, 241, 0.1);
        }

        .gradient-text {
          background: linear-gradient(135deg, #0891b2 0%, #06b6d4 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }

        .input-focus {
          transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
        }

        .input-focus:focus {
          box-shadow: 0 0 20px rgba(6, 182, 212, 0.3), 0 0 40px rgba(99, 102, 241, 0.1);
          transform: translateY(-2px);
        }

        .input-field {
          background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
          border: 1px solid rgba(99, 102, 241, 0.1);
        }

        .input-field:focus {
          background: white;
          border-color: rgba(6, 182, 212, 0.3);
        }

        .button-submit {
          background: linear-gradient(135deg, #06b6d4 0%, #0891b2 100%);
          transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
          position: relative;
          overflow: hidden;
        }

        .button-submit:hover:not(:disabled) {
          transform: translateY(-3px);
          box-shadow: 0 20px 40px rgba(6, 182, 212, 0.3);
        }

        .button-submit:active:not(:disabled) {
          transform: translateY(-1px);
        }

        .button-submit:disabled {
          opacity: 0.7;
          cursor: not-allowed;
        }

        .button-glow {
          position: absolute;
          inset: 0;
          background: linear-gradient(135deg, rgba(255, 255, 255, 0.2) 0%, transparent 100%);
          border-radius: inherit;
        }

        .logo-container {
          animation: floatLogo 3s ease-in-out infinite;
        }

        @keyframes floatLogo {
          0%, 100% {
            transform: translateY(0px);
          }
          50% {
            transform: translateY(-20px);
          }
        }

        .form-container {
          animation: slideInRight 0.6s ease-out forwards;
          opacity: 0;
        }

        @keyframes slideInRight {
          from {
            opacity: 0;
            transform: translateX(30px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        .input-label {
          transition: all 0.3s ease;
        }

        .input-field:focus ~ .input-label,
        .input-field:not(:placeholder-shown) ~ .input-label {
          color: #0891b2;
          font-weight: 600;
        }

        .password-toggle {
          transition: all 0.2s ease;
          color: #9ca3af;
        }

        .password-toggle:hover {
          color: #06b6d4;
          transform: scale(1.2);
        }

        .blur-background {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: linear-gradient(135deg, rgba(6, 182, 212, 0.05) 0%, rgba(99, 102, 241, 0.05) 100%);
          z-index: -1;
        }

        .icon-wrapper {
          background: linear-gradient(135deg, rgba(6, 182, 212, 0.1) 0%, rgba(99, 102, 241, 0.1) 100%);
          border: 1px solid rgba(6, 182, 212, 0.2);
          padding: 8px 12px;
          border-radius: 8px;
          transition: all 0.3s ease;
        }

        .input-field:focus ~ .input-wrapper .icon-wrapper {
          background: linear-gradient(135deg, rgba(6, 182, 212, 0.2) 0%, rgba(99, 102, 241, 0.2) 100%);
          border-color: rgba(6, 182, 212, 0.4);
        }

        .divider-line {
          background: linear-gradient(90deg, transparent 0%, rgba(99, 102, 241, 0.2) 50%, transparent 100%);
          height: 1px;
        }

        .fade-in-form {
          animation: fadeInForm 0.6s ease-out forwards;
        }

        @keyframes fadeInForm {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }

        .fade-in-form:nth-child(1) { animation-delay: 0.1s; }
        .fade-in-form:nth-child(2) { animation-delay: 0.2s; }
        .fade-in-form:nth-child(3) { animation-delay: 0.3s; }
        .fade-in-form:nth-child(4) { animation-delay: 0.4s; }
        .fade-in-form:nth-child(5) { animation-delay: 0.5s; }
      `}</style>

      <div className="blur-background"></div>

      <div className="login-container glass-effect shadow-2xl rounded-3xl w-full max-w-5xl flex flex-col md:flex-row overflow-hidden">
        {/* Logo Section */}
        <div className="hidden md:flex justify-center items-center bg-gradient-to-br from-cyan-50 to-indigo-50 p-10 w-1/2 relative">
          <div className="absolute inset-0 opacity-30">
            <div className="absolute top-10 right-10 w-32 h-32 bg-cyan-200 rounded-full blur-3xl"></div>
            <div className="absolute bottom-10 left-10 w-40 h-40 bg-indigo-200 rounded-full blur-3xl"></div>
          </div>
          <div className="logo-container relative z-10">
            <img
              src={loginicon}
              className="w-80 h-80 object-contain drop-shadow-lg hover:scale-105 transition-transform duration-500"
              alt="DB Skills Logo"
            />
          </div>
        </div>

        {/* Form Section */}
        <div className="w-full md:w-1/2 p-8 md:p-12 flex flex-col justify-center form-container">
          {/* Header */}
          <div className="mb-8">
            <h2 className="text-4xl font-bold gradient-text mb-2">Welcome Back</h2>
            <p className="text-gray-600 text-lg">Login to your admin dashboard</p>
          </div>

          <form className="space-y-5" onSubmit={handleSubmit}>
            {/* Username Field */}
            <div className="fade-in-form">
              <label className="text-sm font-semibold text-gray-700 mb-2 block uppercase tracking-wider">Username</label>
              <div className="relative">
                <input
                  type="text"
                  placeholder="Enter your username"
                  className="input-field input-focus w-full px-4 py-3.5 rounded-xl focus:outline-none"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
                <div className="absolute right-4 top-3.5">
                  <div className="icon-wrapper">
                    <Mail size={20} className="text-cyan-600" />
                  </div>
                </div>
              </div>
            </div>

            {/* Password Field */}
            <div className="fade-in-form">
              <label className="text-sm font-semibold text-gray-700 mb-2 block uppercase tracking-wider">Password</label>
              <div className="relative">
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="Enter your password"
                  className="input-field input-focus w-full px-4 py-3.5 rounded-xl focus:outline-none pr-14"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
                <div className="absolute right-4 top-1/2 -translate-y-1/2 flex gap-2 items-center">
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    className="password-toggle p-2"
                  >
                    {showPassword ? (
                      <FaEye className="text-lg" />
                    ) : (
                      <FaEyeSlash className="text-lg" />
                    )}
                  </button>
                </div>
              </div>
            </div>

            {/* Submit Button */}
            <div className="fade-in-form pt-2">
              <button
                type="submit"
                disabled={loading}
                className="button-submit w-full text-white font-semibold py-3.5 rounded-xl transition-all shadow-lg flex items-center justify-center gap-2 relative group"
              >
                <div className="button-glow group-hover:opacity-100 opacity-0 transition-opacity"></div>
                {loading ? (
                  <>
                    <span className="animate-spin h-5 w-5 border-2 border-white border-t-transparent rounded-full"></span>
                    <span>Logging in...</span>
                  </>
                ) : (
                  <>
                    <LogIn size={20} />
                    <span>Login</span>
                  </>
                )}
              </button>
            </div>

            {/* Divider */}
            <div className="fade-in-form">
              <div className="divider-line"></div>
            </div>

            {/* Footer */}
            <div className="fade-in-form text-center">
              <p className="text-gray-500 text-sm font-medium">© DB Skills Portal 2024</p>
              <p className="text-gray-400 text-xs mt-2">Admin Access Only</p>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;